module.exports = __webpack_public_path__ + "../resources/img/floppy-disk.299390e4.png";